import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {I18n, Translate} from 'react-redux-i18n';
import Modal from 'react-modal';
import {getCroppedImg, Icon, ImageCropper} from 'front-onceforall-core';
import * as snackbarsActions from '../../../../actions/snackbars';
import organisationService from '../../../../services/organisation/OrganisationService';
import {captureError} from '../../../../utils/log';

const styles = {
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.7)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};

class UploadLogoModal extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hasImage: false,
      submitted: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.state.hasImage || this.state.submitted) {
      return;
    }

    this.setState({submitted: true});

    const fetchedImage = this.fetchImage();

    Promise.all([
      getCroppedImg(fetchedImage.fileDataUrl, fetchedImage.croppedAreaPixels),
      getCroppedImg(fetchedImage.fileDataUrl, fetchedImage.croppedAreaPixels, true)
    ])
      .then(([originalFile, mediumFile]) => {
        organisationService.uploadLogo(this.props.organisationId, originalFile, mediumFile)
          .then(() => {
            this.props.actions.addSuccess(<Translate value="uploadLogo.uploadSuccess"/>);
            this.setState({submitted: false});
            this.props.onSubmitSuccess();
          })
          .catch(error => {
            this.props.actions.addError(<Translate value="error.generic"/>);
            this.setState({submitted: false});
            captureError('organisationService.uploadLogo', error);
            this.props.onClose();
          });
      });
  }

  render() {
    const submitButton = (
      <button
        className="large primary inline-container"
        id="submit"
        type="submit"
        disabled={!this.state.hasImage}
      >
        <Icon icon={this.state.submitted ? 'loader' : 'check'}/>
        <Translate value="action.confirm"/>
      </button>
    );

    return (
      <Modal
        defaultStyles={styles}
        isOpen={this.props.modalUploadIsOpen}
        onRequestClose={this.props.onClose}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <form onSubmit={this.handleSubmit}>
          <div
            className="col-xl-5 col-lg-6 col-md-10 modal-container-upload"
            style={{padding: 20}}
          >
            <div className="inline-container column col-12 center">
              <h3><Translate value="uploadLogo.title"/></h3>
            </div>
            <ImageCropper
              fetchImageFunction={fnc => {
                this.fetchImage = fnc;
              }}
              onHasImage={hasImage => this.setState({hasImage})}
            />
            <div className="actions col-12 inline-container space-between">
              <button
                type="button"
                className="large secondary inline-container"
                onClick={this.props.onClose}
                data-id="cancel"
              >
                <Icon icon="go-back"/>
                <Translate value="action.cancel"/>
              </button>
              {this.state.hasImage ?
                submitButton :
                <span
                  tooltip={I18n.t('message.missingRequiredFields')}
                  flow="left"
                >{submitButton}</span>
              }
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

UploadLogoModal.propTypes = {
  organisationId: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  modalUploadIsOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(UploadLogoModal);
